<div class="questionnaire-history-detail">
  <div class="detail-header">
    <div class="detail-header-title">
      {{ getQuestionnaireTitle() }}
    </div>
    <button nz-button nzType="default" type="button" (click)="backToHistory()">
      <nz-icon nzType="arrow-left" nzTheme="outline" />
      <span>{{ "Back" | translate }}</span>
    </button>
  </div>

  @if (isLoading) {
    <div class="detail-state">
      <nz-spin [nzSpinning]="true" nzSize="large"></nz-spin>
    </div>
  }

  @if (!isLoading && error) {
    <div class="detail-state detail-error">
      {{ error }}
    </div>
  }

  @if (!isLoading && !error && canRenderQuestionnaireScreen()) {
    @if (item?.questionnaire?.localizationAvailable === false) {
      <p role="status">{{ "Questionnaire translation unavailable; original labels retained." | translate }}</p>
    }
    @if (shouldShowSummary()) {
      <div class="detail-summary">
        <div class="summary-card">
          <span class="summary-label">{{ "Status" | translate }}</span>
          <span class="summary-value">{{ getStatus() }}</span>
        </div>
        <div class="summary-card">
          <span class="summary-label">{{ "Visit / Episode" | translate }}</span>
          <span class="summary-value">{{ getVisitContext() }}</span>
        </div>
        <div class="summary-card">
          <span class="summary-label">{{ "Created date" | translate }}</span>
          <span class="summary-value">{{ getCreatedDate() }}</span>
        </div>
        <div class="summary-card">
          <span class="summary-label">{{ "Submitted" | translate }}</span>
          <span class="summary-value">{{ getSubmittedDate() }}</span>
        </div>
        <div class="summary-card">
          <span class="summary-label">{{ "Submitted by" | translate }}</span>
          <span class="summary-value">{{ getActor() }}</span>
        </div>
        @if (shouldShowScoreSummary()) {
          <div class="summary-card">
            <span class="summary-label">{{ "Score" | translate }}</span>
            <span class="summary-value">{{ getScoreSummary() }}</span>
          </div>
        }
      </div>
    }

    @if (questionnaireTemplateId === 1) {
      <app-dynamic-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 2) {
      <app-fast-protocol-mediterranean-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 3) {
      <app-nih-stroke-score-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 4) {
      <app-speech-therapy-pd-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 5) {
      <app-gds-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 6) {
      <app-speech-therapy-bdi-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 7) {
      <app-speech-therapy-ocad-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 8) {
      <app-neuro-berg-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 9) {
      <app-physiotherapy-pac-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 10) {
      <app-sldc-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 11) {
      <app-slag-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 12) {
      <app-dn4-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 13) {
      <app-eq5d-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 14) {
      <app-mobid-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 15) {
      <app-painad-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 16) {
      <app-pacslac2-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 17) {
      <app-mfis-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 18) {
      <app-mrc-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 19) {
      <app-mini-bestest-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 20) {
      <app-fugl-meyer-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 21) {
      <app-trunk-control-test-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 22) {
      <app-trunk-impairment-scale-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 23) {
      <app-six-minute-walk-test-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 24) {
      <app-ten-meter-walk-test-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 25) {
      <app-fac-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 26) {
      <app-fga-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 27) {
      <app-tug-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 28) {
      <app-mas-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 29) {
      <app-barthel-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 30) {
      <app-fim-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
    @if (questionnaireTemplateId === 31) {
      <app-motricity-index-questionnaire
        [readonlyMode]="isReadonlyMode()"
        [historicalItem]="item"
        [useHistoricalAnswers]="shouldUseHistoricalAnswers()"
        [startWithBlank]="shouldStartBlank()"
        [returnToTableAfterSubmit]="shouldReturnToHistoryAfterSubmit()"
        (questionnaireSubmitted)="handleQuestionnaireSubmitted()"
      />
    }
  }
</div>
